import React, {Component} from 'react';
import {
  AppFooter,
  AppHeader,
} from '@coreui/react';
import './Style.css'
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";

import DefaultHeader from "./ParkHeader";
import DefaultFooter from "../DefaultLayout/DefaultFooter";
import Cookies from "js-cookie";
import JWT_Decode from "jwt-decode";
import {PropagateLoader} from "react-spinners";

class ParkLayout extends Component {
  state = {
      loader:true
  };

  loading = () => <span/>;

  manageIframe = () => {
    this.setState({
      loader:false
    })
  };

  componentWillMount() {
    // for parktags -----------------------------------------------
    let token = Cookies.get("68a6102f6ed24899420170004a0273b8");
    let decode_token = JWT_Decode(token);

    decode_token.access_token = Cookies.get("68a6102f6ed24899420170004a0273b8");
    decode_token.refresh_token = Cookies.get("9b8558ba3f051677daf36ebfc67f29fa");

    decode_token.userId = decode_token.user.userId;
    decode_token.userRoles = decode_token.user.userRoles;
    decode_token.corporates = decode_token.user.corporates;

    sessionStorage.setItem("userData",JSON.stringify(decode_token));

    localStorage.setItem("userData",JSON.stringify(decode_token));
    localStorage.setItem("userId",decode_token.user.userId);
    localStorage.setItem("userRoles",decode_token.user.userRoles);
    // -----------------------------------------------------------
  }

  componentDidMount() {
    document.title = "ParkTags";
  }

  signOut(e) {
    e.preventDefault();
    Cookies.remove("68a6102f6ed24899420170004a0273b8");
    this.props.history.push('/login')
  }

  render() {
    return (
      <div className="app">
        <AppHeader fixed>
          <DefaultHeader onLogout={e => this.signOut(e)}/>
        </AppHeader>

        {
          this.props.system_changer === 1 ?
            <div className="app-body">
              {
                this.state.loader ?
                  <div>
                    <div className="ant-modal-mask" style={{background: 'rgba(239, 239, 239, 0.4)'}}>
                    </div>

                    <div tabIndex="-1" style={{zIndex: '10000'}} className="ant-modal-wrap vertical-center-modal"
                         role="dialog">
                      <div className={"wrap-sweet-loading"}>
                        <div className='sweet-loading'>
                          <PropagateLoader
                            sizeUnit={"px"}
                            size={this.props.size ? this.props.size : 15}
                            color={this.props.color ? this.props.color : '#0085ca'}
                            loading={this.state.loading}
                          />
                        </div>

                      </div>
                    </div>
                  </div>
                  :null
              }
              {/*src="/parktags/index.html"*/}
              <iframe src="/parktags/index.html" className={"iframe-tags parktags-iframe"} id={"iframe"}
                      onLoad={this.manageIframe}/>
            </div> : null

        }

        {
          this.props.system_changer !== 1 ?
            <AppFooter>
              <DefaultFooter/>
            </AppFooter>
            : null
        }

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  system_changer: state.systemChangeReducer.system_changer
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    systemChangeHandler: (data) => dispatch(actionCreator.systemChangeHandler(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ParkLayout);
